import React, { useEffect, useState } from 'react';
import styles from './CalendarTabs.module.scss';
import GeneralCalendar from '../../templates/academicCalendarTemplate/generalCalendar/GeneralCalendar';
import endpoints from '../../../api/endpoints';
import { useGetQuery } from '../../../services/apiCall';

const CalendarTabs = ({
  id,
  activeYearId: externalYearId,
  setActiveYearId: setExternalYearId,
  tabs: externalTabs,
}) => {
  const tabs = [
    {
      id: 0,
      title: '2023 - 2024',
      apiId: '62B02A29-E9D2-463D-93EB-A75622983565',
    },
    {
      id: 1,
      title: '2024 - 2025',
      apiId: '557F586F-D70F-48BE-81DF-97070721DD1E',
    },
    {
      id: 2,
      title: '2025 - 2026',
      apiId: '62B02A29-E9D2-463D-93EB-A756229835652',
    },
  ];
  const isControlled =
    typeof externalYearId !== 'undefined' &&
    typeof setExternalYearId === 'function';
  const apiUrl = endpoints.calendar.getCalendarByYear;
  const [section, setSection] = useState(0);
  const [internalYearId, setInternalYearId] = useState(tabs[1].apiId);
  const activeYearId = isControlled ? externalYearId : internalYearId;
  const setActiveYearId = isControlled ? setExternalYearId : setInternalYearId;
  const params = [id, activeYearId];
  const { data, error, isLoading, refetch } = useGetQuery({
    apiUrl: apiUrl,
    params: params,
  });

  useEffect(() => {
    refetch();
  }, [activeYearId, id]);
  const handleTouchStart = (event) => {
    event.stopPropagation();
  };

  const handleTouchMove = (event) => {
    event.stopPropagation();
  };
  return (
    <div
      className={styles['calendar-tabs']}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
    >
      <div className={styles['tab-content']}>
        <GeneralCalendar
          id={section}
          dataTable={error ? [] : data}
          tabs={tabs}
          activeYearId={activeYearId}
          setActiveYearId={setActiveYearId}
          isLoading={isLoading}
          isHomePage
          externalTabs={externalTabs}
        />
      </div>
    </div>
  );
};

export default CalendarTabs;
